import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.CHECKLISTS_SCIPR_MANAGE}`,
            render: () => import("../../Pages/Nursing/SciprForm/SciprForm.svelte"),
            title: "SCIP-R Form"
        }
    ]
};

export default routerConfig;
